import { CreateAccountingPostingFormSearchParams } from "src/admin/forms/accounting-posting/contants.ts";
import React from "react";
import { ResourceForm } from "src/components/Form/ResourceForm.tsx";
import { FormAction } from "src/components/Form/Form.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const renderCustomForm = ({
  searchParams,
}: {
  searchParams: URLSearchParams;
}) => {
  const showAssignOrderForm = searchParams.has(
    CreateAccountingPostingFormSearchParams.ShowAssignOrderForm,
  );
  const hasBankTransactionId = searchParams.has(
    CreateAccountingPostingFormSearchParams.BankTransactionId,
  );

  if (!showAssignOrderForm || !hasBankTransactionId) {
    return null;
  }

  const id = searchParams.get(
    CreateAccountingPostingFormSearchParams.BankTransactionId,
  )!;
  return (
    <ResourceForm
      id={id}
      action={FormAction.Edit}
      resource={ResourceEnum.BankTransaction}
    />
  );
};
